module.exports = __webpack_public_path__ + "img/ntv-premium-64x64.fbd9d4d4.png";